import { MdDone } from "react-icons/md";

const DoneIcon = (props) => {
  return <MdDone className={props.className} />;
};

export default DoneIcon;
